import camelcaseKeys from 'camelcase-keys';

export const getters = {
  getClients($state) {
    return $state.sortOrder.map(clientId => $state.records[clientId]);
  },
  getClientsList($state) {
    const clients = $state.sortOrder.map(clientId => $state.records[clientId]);
    return camelcaseKeys(clients, { deep: true });
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getClient: $state => id => {
    const client = $state.records[id];
    return client || {};
  },
  getClientById: $state => id => {
    const client = $state.records[id];
    return camelcaseKeys(client || {}, {
      deep: true,
      stopPaths: ['custom_attributes'],
    });
  },
  getMeta: $state => {
    return $state.meta;
  },
  getAppliedClientFilters: _state => {
    return _state.appliedFilters;
  },
  getAppliedClientFiltersV4: _state => {
    return _state.appliedFilters.map(camelcaseKeys);
  },
};
